<template>
    <embed width=100% height=100% type="application/pdf" :src="certificate"/>
</template>

<script>
import publicApi from '@/services/public.js'

export default {
    components: {
    },
    data() {
        return {
            certificate : ""
        }
    },
    methods : {
        async getCertificate() {
            let url = (this.$route.name == "Certificate") ? '/lsa/certificate/'+parseInt(this.$route.params.user) : (this.$route.name == "DcplusCertificate") ? '/lsa/certificate/'+parseInt(this.$route.params.user)+'/plus' : ''
            await publicApi.get(url)
            .then(response => {
                this.certificate = "data:application/pdf;base64, "+response.data[0]
            })
            .catch(error => {
                if (error.response.status == 303 || error.response.status == 404 || error.response.status == 403) {
                    console.log("erreur")
                }
            })
        },
    },
    created () {
        this.getCertificate();
    }
}
</script>

<style scoped>
/* body {
    height: fit-content;
} */
embed {
    min-height: 100vh;
}
</style>